import * as React from 'react';

import { trackDeleteOfferNote, trackOpenOfferNote } from './tracking';
import { Note } from '../../../components/OfferCard/Note';
import { useOfferContext } from '../../../context';
import { useAppDispatch } from '../../../hooks';
import { noteActions } from '../../../slices';
import { EUpdateNoteAction, updateOfferNote } from '../../../thunks';

export const OfferNoteContainer = () => {
  const { offer, position } = useOfferContext();

  const { notes } = offer;
  const offerNote = notes?.offer?.text;

  const dispatch = useAppDispatch();

  const handleOpenEditing = React.useCallback(() => {
    dispatch(noteActions.setIsEditing({ isEditing: true, offer, position }));
    trackOpenOfferNote(offer.id ?? undefined, position);
  }, [dispatch, offer, position]);

  const handleDeleteNote = React.useCallback(() => {
    dispatch(updateOfferNote({ text: undefined, action: EUpdateNoteAction.Delete, offer }));
    trackDeleteOfferNote(offer.id ?? undefined, position);
  }, [dispatch, offer, position]);

  if (!offerNote) {
    return null;
  }

  return <Note note={offerNote} onEdit={handleOpenEditing} onDelete={handleDeleteNote} />;
};
